import { readLoggedIn } from "~/utils/logInCookiesCRUD";
import {
  deleteLoggedAsAdmin,
  readLoggedAsAdmin,
} from "~/utils/adminCookiesCRUD";
import { queryClient } from "~/plugins/vue-query";
import { authService } from "~/utils/api/authService";
import type { ResponseError } from "~/utils/responseError";

export default defineNuxtRouteMiddleware(async (to) => {
  if (readLoggedIn() === undefined) {
    if (readLoggedAsAdmin()) {
      deleteLoggedAsAdmin();
    }
    return navigateTo("/login");
  }

  try {
    const userData = await queryClient.fetchQuery({
      queryKey: ["user"],
      queryFn: authService.getAccount,
    });

    const adminAccountTypes = ["admin", "engineer"];

    if (
      adminAccountTypes.includes(userData?.account_type) &&
      !to.path.startsWith("/admin")
    ) {
      return navigateTo("/admin");
    }
    if (userData?.account_type === "client" && to.path.startsWith("/admin")) {
      return navigateTo("/");
    }
  } catch (error: unknown) {
    const responseError = error as ResponseError;

    if (responseError.status === 401) {
      return navigateTo("/login");
    }

    if (
      responseError.status === 403 &&
      responseError.message?.includes("User is not client")
    ) {
      return navigateTo("/admin");
    }
  }
});
